export default __webpack_public_path__ + "static/media/article2.9b95afbc.jpeg";